import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7AB2D3", // soft blue rgb-122, 178, 211

    },
    secondary: {
      main: "#4A628A", // dark blue
    },
    background: {
      default: "#DFF2EB", // mint green
    },
    info: {
      main: "#B9E5E8", // light teal
    },
  },
  typography: {
    
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
  },
});

export default theme;

